import { render, staticRenderFns } from "./smallItem2.vue?vue&type=template&id=1fcdb2a9&scoped=true&"
import script from "./smallItem2.vue?vue&type=script&lang=ts&"
export * from "./smallItem2.vue?vue&type=script&lang=ts&"
import style0 from "./smallItem2.vue?vue&type=style&index=0&id=1fcdb2a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fcdb2a9",
  null
  
)

export default component.exports